// extracted by mini-css-extract-plugin
export var header = "_xi-1";
export var maskBottom = "_xi-6";
export var maskMiddle = "_xi-7";
export var maskTop = "_xi-5";
export var root = "_xi-0";
export var scrollDownButton = "_xi-3";
export var scrollDownButtonHidden = "_xi-4";
export var viewport = "_xi-2";